module.exports = __webpack_public_path__ + "d76e82536e1f6beed61f6f6d9ef2bc81.svg";